import { AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { useHttpClient } from "../../../../shared/http/HttpClientProvider";
import { MutationOptions, MutationResult } from '../../../../shared/types/query';

export function usePostNewSession(options?: MutationOptions<void, AxiosResponse<any>>): MutationResult<void, AxiosResponse<any>> {
    const http = useHttpClient();

    return useMutation({
        ...options,
        mutationKey: ['sessions/new', http],
        mutationFn: () => {
            return http.request({
                method: 'post',
                url: '',
                data: {
                    sessionType: "ManagementSession",
                    sessionTTL: 300,
                    appVersion: "2.7.43.1709",
                    clientType: "3:0",
                }
            })
        },
    })
}